import { InjectionToken } from '@angular/core';
export const serverUrlToken = new InjectionToken<string>('serverUrl');
export const versionToken = new InjectionToken<string>('version');
export const isUserLoggedInToken = new InjectionToken<string>('isUserLoggedIn');
